<div class="bm-payment-plan-balance">
    <p-card class="border-round-md">
        <ng-template pTemplate="header">
            <div class="balance-header pb-0">
                <h4 class="m-0">Rechnungsübersicht</h4>
            </div>
        </ng-template>

        <ng-template pTemplate="content">
            <div class="balance-content py-0">

                <div class="ledger">

                    <!-- ========== CHARGES ========== -->


                    @for (item of balanceEntries; track item.id) {
                        @if (item.type === 'charge' || item.type === 'charge-removal' || item.type === 'charge-reduction') {
                            <div class="ledger-row">

                                <div class="ledger-left">
                                    <div class="title">{{ item.name }}</div>
                                </div>

                                <div class="ledger-right negative">
                                    <span>{{ item.amount | number:'1.2-2' }} €</span>
                                    <span class="w-2rem">
                                        <i
                                                *ngIf="item.removable"
                                                class="pi pi-trash cancel-icon"
                                                (click)="removeEntry(item)">
                                        </i>
                                    </span>
                                </div>

                            </div>
                        }
                    }


                    <!-- ========== CONTRACTS ========== -->

                    @if (hasContractEntries()) {
                        <div class="ledger-divider"></div>

                        @for (item of balanceEntries; track item.id) {
                            @if (item.type === 'contract-dunning' || item.type === 'contract-reactivation') {

                                <div class="ledger-row">
                                    <div class="ledger-left">
                                        <div class="title">{{ item.name }}</div>
                                        <div class="subtitle">
                                            {{ getEntryTypeLabel(item.type) }}
                                        </div>
                                    </div>

                                    <div class="ledger-right negative">
                                        <span>{{ item.amount | number:'1.2-2' }} €</span>
                                        <span class="w-2rem">
                                        <i
                                                *ngIf="item.removable"
                                                class="pi pi-trash cancel-icon"
                                                (click)="removeEntry(item)">
                                        </i>
                                    </span>
                                    </div>
                                </div>
                            }
                        }
                    }



                    <!-- ========== ONE TIME PAYMENTS ========== -->

                    @if (hasOneTimePayments()) {
                        <div class="ledger-divider"></div>

                        @for (item of balanceEntries; track item.id; let idx = $index) {
                            @if (item.type === 'one-time-payment') {
                                <div class="ledger-row">
                                    <div class="ledger-left">
                                        <div class="title">{{ item.name }}</div>
                                        <div class="subtitle">
                                            {{ item.timestamp | date:'dd.MM.yyyy' }}
                                        </div>
                                    </div>

                                    <div class="ledger-right positive">
                                        <span>{{ item.amount | number:'1.2-2' }} €</span>
                                        <span class="w-2rem">
                                        <i
                                                *ngIf="item.removable"
                                                class="pi pi-trash cancel-icon"
                                                (click)="removeEntry(item)">
                                        </i>
                                    </span>
                                    </div>
                                </div>
                            }
                        }
                    }


                    <!-- ========== TOTAL ========== -->
                    <div class="ledger-row total">
                        <div></div>
                        <div class="ledger-right negative">
                            {{ totalBalance | number:'1.2-2' }} €
                        </div>
                    </div>

                </div>
            </div>
        </ng-template>
    </p-card>


    <p-card class="mt-3 border-round-md">
    <div class="border-round-md flex flex-column gap-3 w-full">
        <span> Add subsequent bookings manually </span>
        <p-button
                (click)="openOneTimePaymentDialog()"
                label="Add Manually"
                styleClass="w-full"
        ></p-button>
    </div>
    </p-card>

</div>


<bm-one-time-payment-dialog
        [(visible)]="showOneTimePaymentDialog"
        defaultName="">
</bm-one-time-payment-dialog>
